import TypesComplaintsTable from "../../components/Tables/TypesComplaints/TypesComplaintsTable";
import UsersComplaintsTable from "../../components/Tables/UsersComplaints/UsersComplaintsTable";

import { typeOfComplaints } from "./constants";

export const complaintsConfig = {
    [typeOfComplaints.types]: <TypesComplaintsTable />,
    [typeOfComplaints.users]: <UsersComplaintsTable />,
};
